<template>
  <appointments-list></appointments-list>
</template>

<script>
export default {
  methods: {
    trackMixpanelViewEvent() {
      if (this.$warehouseId && this.$warehouseOrgId) {
        this.mixpanel.track(this.mixpanel.events.VIEW.MY_APPOINTMENTS_PAGE, {
          'Warehouse ID': this.$warehouseId,
          'Org ID': this.$warehouseOrgId
        });
      }
    }
  },
  mounted() {
    this.$store.commit('Appointments/setResponseMetaData', null);
    this.trackMixpanelViewEvent();
  },
  watch: {
    $warehouseId() {
      this.trackMixpanelViewEvent();
    },
    $warehouseOrgId() {
      this.trackMixpanelViewEvent();
    }
  }
};
</script>
